<script setup lang="ts">
import { onMounted, reactive, ref, unref } from "vue";
import { WxTicket } from "@/api/wxTicket";
import { Button, Popup, Toast, Loading, Dialog } from "vant";
import { useRoute } from "vue-router";
import html2canvas from "html2canvas";
import { getCookie } from "@/utils/service/request";
import ClipboardJS from "clipboard";
import {
  Activity,
  GroupShareResponse,
  startGroupResponse,
} from "@/api/activity";
import {
  initConfig,
  updateAppMessageShareData,
  updateTimelineShareData,
  getUserAuthorize,
} from "@/hooks/useWxSDK";
import { useClipboard } from "@vueuse/core";
import { mobileModels } from "@/utils/mobileModels";
import QrcodeVue from "qrcode.vue";
import useShare from "./hooks/useShare";
import { isAuto } from "html2canvas/dist/types/render/background";
//CSS 接口
type Cls = {
  isDisplay: boolean;
};

const OA_URL = ref<string>(
  "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU3MDY1ODQ5OA==&scene=124#wechat_redirect"
);

const VanDialog = Dialog.Component;
const showDialog = ref<boolean>(false);

const cssFlag: Cls = reactive({
  isDisplay: false,
});
interface BoolInfoState {
  bookName: string;
  coverUrl: string;
  previewList: Array<string>;
}

const props = defineProps<{ pid: string }>();

const isSuccess = ref<boolean>(false);
const isFailed = ref<boolean>(false);
const showShareRef = ref<boolean>(false);
const wechatStatus = ref<boolean>(false); //微信状态
const wechatShareStatus = ref<boolean>(false); //微信分享状态
// const mkBenefitsPackageBookRef = ref<Array<mkBenefitsPackageBookResponse>>([]);

// const options = [{ name: "微信", icon: "wechat" }];
const source = ref<string>("");

const route = useRoute();
const { isWeixin } = useShare();

const { aid, login, code, state, isLogin } = route.query;
source.value = `${process.env.VUE_APP_WX_URL}/bookgroupdisplay/?aid=${aid}&pid=${props.pid}`;
console.log(source.value);

interface JsonType {
  title: string;
  content: string;
}
interface BeginGuideBtnType {
  btnName: string;
  url: string;
}
const dataInfo = reactive<startGroupResponse>({
  id: 0,
  endTime: 0, //	结束时间(时间戳)
  activitySharePosterUrl: "", //	开始组团页  分享海报
  activityShareBtn: "", //活动分享按钮
  openGroupExplain: "", //开团说明
  openGroupText: "", //开团文案
  beginGuideBtn: "", //活动分享按钮 按钮名称
  successGuideBtn: "",
  totalMember: 0, //总共的参团人数
  joinMember: 0, //参加的人数
  bannerUrls: "",
  openGroupSuccessUrl: "", //组团成功提示图片
});
const shareInfo = reactive<GroupShareResponse>({
  id: 0, //id
  shareTitle: "", //分享标题
  shareText: "", //分享文本
  shareImgUrl: "", //分享图片
});

const openGroupTextArr = ref<Array<JsonType>>([]); //开团文案
const openGroupTextArrNewUser = ref<Array<string>>([]); //新用户开团文案内容
const openGroupTextTitleNewUser = ref<string>(""); //新用户开团文案标题
const openGroupTextArrOldUser = ref<Array<string>>([]); //老用户开团文案内容
const openGroupTextTitleOldUser = ref<string>(""); //老用户开团文案标题

const beginGuideBtnObj = ref<BeginGuideBtnType>({
  btnName: "",
  url: "",
});
const successGuideBtnObj = ref<BeginGuideBtnType>({
  btnName: "",
  url: "",
});
const bannerUrlsArr = ref<Array<string>>([]);

//计算倒计时
const d = ref<number>();
const h = ref<number>(0);
const m = ref<number>(0);
const s = ref<number>(0);
const getTimeFunc = () => {
  //获取当前时间
  let nowTime = new Date().getTime();
  const time = new Date(dataInfo.endTime);
  // console.log(time)
  const end = time.getTime();
  //时间差
  let gapTime = end - nowTime;
  // console.log(gapTime)
  if (gapTime >= 0) {
    d.value = Math.floor(gapTime / 1000 / 60 / 60 / 24);
    h.value = Math.floor((gapTime / 1000 / 60 / 60) % 24);
    m.value = Math.floor((gapTime / 1000 / 60) % 60);
    s.value = Math.floor((gapTime / 1000) % 60);
  }
};
setInterval(getTimeFunc, 1000);

const flag = ref<boolean>(false);

const isTeamHimSelfIn = ref<boolean>(false);

const onSelect = (value: string) => {
  show.value = false;

  if (value === "复制链接") {
    const { copy, isSupported, text, copied } = useClipboard({
      source,
      read: true,
    });
    copy();
    console.log(isSupported, text, copied);

    Toast("复制成功");
  }
  if (value === "发给朋友") {
    if (!isWeixin()) {
      const { copy, isSupported, text, copied } = useClipboard({
        source,
        read: true,
      });
      copy();
      console.log(isSupported, text, copied);
      Toast("复制成功"); //不是微信就复制链接
    } else {
      wechatShareStatus.value = true;
    }
  }
};
function OffWechatBgClick() {
  wechatStatus.value = false;
  (document.querySelector("body") as HTMLBodyElement).style.overflowY = "auto";
}

function OffWechatShareClick() {
  wechatShareStatus.value = false;
  (document.querySelector("body") as HTMLBodyElement).style.overflowY = "auto";
}

//打开App
function openApp() {
  // wechatStatus.value = isWeixin();
  // console.log(wechatStatus.value);
  // if (wechatStatus.value) {
  //   (document.querySelector("body") as HTMLBodyElement).style.overflowY =
  //     "hidden";
  // } else {
  // let brand = mobileModels(navigator.userAgent.toLowerCase());
  // if (["iPad", "iphone"].includes(brand)) {
  //   window.open(
  //     "https://apps.apple.com/us/app/pptutor%E4%B8%AD%E6%96%87/id1548091746"
  //   );
  // } else if (brand === "huawei") {
  //   window.open("https://appgallery.huawei.com/app/C103636233");
  // } else {
  //安卓打开谷歌
  //   window.open(
  //     "https://play.google.com/store/apps/details?id=com.pptutor_lite"
  //   );
  // }
  window.open(`${beginGuideBtnObj.value.url}`);
  // }
}
function openSuccessApp() {
  window.open(`${successGuideBtnObj.value.url}`);
}
function setCookie(cookiename: any, cookievalue: any) {
  const date = new Date();
  // if (type === 'milsecond') {
  //   date.setTime(date.getTime() + milsecond)
  // } else {
  date.setDate(date.getDate() + 99999);
  // }
  document.cookie =
    cookiename +
    "=" +
    cookievalue +
    ";expires = " +
    date.toUTCString() +
    ";path=/";
}
let openGroupExplainArr = ref<Array<string>>([]);
onMounted(async () => {
  const { aid, isLogin, isAuto } = route.query;
  setCookie("aid", aid);
  const xxx = String(isLogin);

  console.log(xxx);

  const yyy = String(isAuto);

  isTeamHimSelfIn.value = yyy === "true" ? true : false;

  if (xxx === "false") {
    flag.value = false; //老用户
  } else {
    flag.value = true; //新用户
  }
  try {
    const res = await Activity.startGroupDataGet({ id: Number(aid) });
    dataInfo.id = res.id;
    dataInfo.bannerUrls = res.bannerUrls;
    dataInfo.endTime = res.endTime;
    dataInfo.activitySharePosterUrl = res.activitySharePosterUrl;
    dataInfo.activityShareBtn = res.activityShareBtn;
    dataInfo.openGroupExplain = res.openGroupExplain;

    openGroupExplainArr.value = dataInfo.openGroupExplain.split("#");

    dataInfo.openGroupText = res.openGroupText;
    dataInfo.beginGuideBtn = res.beginGuideBtn;
    dataInfo.successGuideBtn = res.successGuideBtn;

    dataInfo.totalMember = res.totalMember; //组团成功需要的人数
    dataInfo.joinMember = res.joinMember; //参与组团的人数
    if (dataInfo.joinMember >= dataInfo.totalMember - 1) {
      isSuccess.value = true;
    } else {
      isFailed.value = true;
    }
    dataInfo.openGroupSuccessUrl = res.openGroupSuccessUrl; //参与组团的人数

    openGroupTextArr.value = JSON.parse(dataInfo.openGroupText);

    console.log(openGroupTextArr.value);

    openGroupTextArrNewUser.value =
      openGroupTextArr.value[0].content.split("#");

    openGroupTextTitleNewUser.value = openGroupTextArr.value[0].title;

    console.log("新用户文案", openGroupTextTitleNewUser.value);

    openGroupTextArrOldUser.value =
      openGroupTextArr.value[1].content.split("#");

    openGroupTextTitleOldUser.value = openGroupTextArr.value[1].title;

    console.log("老用户文案", openGroupTextTitleOldUser.value);

    beginGuideBtnObj.value = JSON.parse(dataInfo.beginGuideBtn);
    successGuideBtnObj.value = JSON.parse(dataInfo.successGuideBtn);
    bannerUrlsArr.value = dataInfo.bannerUrls.split(",");
  } catch (error) {
    console.log("报错了报错了报错了");
    console.log(error);
  }

  try {
    const resShare = await Activity.groupShare({ id: Number(aid) });
    shareInfo.shareTitle = resShare.shareTitle;
    shareInfo.shareText = resShare.shareText;
    shareInfo.shareImgUrl = resShare.shareImgUrl;
  } catch (error) {
    console.log(error);
  }

  try {
    //判断是不是微信
    if (isWeixin()) {
      try {
        // 获取订阅状态
        const res = await Activity.getSubscriptionStatus({
          userId: Number(props.pid),
        });
        if (!res.isSub) {
          // 获取用户授权 weChat
          if (!code) {
            console.log(window.location.href);
            const redirectUri = encodeURIComponent(window.location.href);
            getUserAuthorize(
              process.env.VUE_APP_WX_APP_ID as string,
              redirectUri
            );
            return;
          }
          // 请求订阅通知
          setTimeout(async () => {
            const result = await Dialog.confirm({
              message: "请允许通知\n" + "朋友参与后我们会通知您",
              theme: "round-button",
            });
            if (result === "confirm") {
              const res = await Activity.subscriptionNotify({
                userId: Number(props.pid),
                code: code as string,
              });
              if (!res.isSubscriptionOA) {
                showDialog.value = true;
              } else {
                await Dialog.alert({
                  message: "订阅通知成功",
                });
              }
            }
          }, 1000 * 3);
        }
      } catch (e) {
        console.log(e);
      }
      const { ticket } = await WxTicket.getWxTicket();
      await initConfig(
        {
          appId: process.env.VUE_APP_WX_APP_ID as string,
          timestamp: parseInt(String(new Date().getTime() / 1000)), //时间戳
          nonceStr: "asdfaskldjflkajskd", //随机字符串
        },
        ticket,
        window.location.href
      );
      const shareParams = {
        title: shareInfo.shareTitle, // 分享标题
        desc: shareInfo.shareText, // 分享描述
        link: source.value, //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareInfo.shareImgUrl, //分享图标
        success() {
          // 用户确认分享后执行的回调函数
          console.log("success");
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          console.log("cancel");
        },
      };
      console.log({
        title: shareInfo.shareTitle, // 分享标题
        desc: shareInfo.shareText, // 分享描述
        link: source.value, //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareInfo.shareImgUrl, //分享图标
      });
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      updateAppMessageShareData(shareParams);
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      updateTimelineShareData(shareParams);
    }
  } catch (error) {
    console.log(error);
  }
});

const show = ref<boolean>(false);
const showPoster = ref<boolean>(false);
const shareClickBtn = () => {
  show.value = true;
};
const imgBox = ref<InstanceType<typeof Popup> | null>(null);
const shareImage = ref<string>("");
const getPoster = () => {
  show.value = false;
  showPoster.value = true;
  const shareImageHeight = (document as any).querySelector(
    "#imgBox>img"
  ).clientHeight;
  console.log(shareImageHeight);
  html2canvas((document as any).getElementById("imgBox"), {
    width: window.innerWidth,
    height: shareImageHeight,
    useCORS: true,
  }).then(function (canvas) {
    shareImage.value = canvas.toDataURL();
  });
};
const clipboard = new ClipboardJS(".copy-link");

clipboard.on("success", function (e) {
  console.info("Action:", e.action);
  console.info("Text:", e.text);
  console.info("Trigger:", e.trigger);
  Toast("复制成功"); //不是微信就复制链接

  e.clearSelection();
});

clipboard.on("error", function (e) {
  console.error("Action:", e.action);
  console.error("Trigger:", e.trigger);
});

const clipboardWeixin = new ClipboardJS(".copy-weixin-link");

clipboardWeixin.on("success", function (e) {
  console.info("Action:", e.action);
  console.info("Text:", e.text);
  console.info("Trigger:", e.trigger);
  if (!isWeixin()) {
    Toast("复制成功"); //不是微信就复制链接
  } else {
    wechatShareStatus.value = true;
  }

  e.clearSelection();
});

clipboardWeixin.on("error", function (e) {
  console.error("Action:", e.action);
  console.error("Trigger:", e.trigger);
});

function refresh() {
  window.location.href =
    window.location.origin +
    window.location.pathname +
    `?aid=${aid}&isLogin=${isLogin}&isAuto=true}`;
}
</script>

<template>
  <!-- <qrcode-vue :value="source" :size="size" level="H" /> -->

  <div class="wechat-background" v-if="wechatStatus" @click="OffWechatBgClick">
    <img src="@/assets/images/guide-index.png" />
    <img class="off-icon" src="@/assets/images/off-icon.png" />
  </div>

  <div
    class="wechat-background"
    v-if="wechatShareStatus"
    @click="OffWechatShareClick"
  >
    <img src="@/assets/images/guide-index-wx-share.png" />
    <img class="off-icon" src="@/assets/images/off-icon.png" />
  </div>
  <!-- 组团成功 -->
  <div class="container-layout" v-show="isSuccess">
    <div class="container-top">
      <img :src="dataInfo.openGroupSuccessUrl" alt="" />
    </div>

    <div>
      <div class="getBookStatusSuccess">
        <div class="getBookStatus-title-success">
          <span>
            <img
              class="right"
              src="../../assets/activity/pages/right.svg"
              alt=""
            />
          </span>
          已完成拼团，恭喜！
        </div>
        <div class="getBookStatus-content-success">
          <p>
            {{ openGroupExplainArr[0] }}
          </p>
          <p>
            {{ openGroupExplainArr[1] }}
          </p>
        </div>

        <div class="content-wrapper-avatar-success">
          <div></div>
          <div class="content-wrapper-avatar-item">
            <img src="../../assets/activity/pages/join-people-1.png" alt="" />
          </div>
          <div class="content-wrapper-avatar-item content-wrapper-avatar-two">
            <img src="../../assets/activity/pages/join-people-2.png" alt="" />
          </div>
          <div>
            <!-- 组团成功有两种情况 -->
            <div
              v-if="dataInfo.totalMember === 3"
              class="content-wrapper-avatar-item content-wrapper-avatar-three"
            >
              <img
                src="../../assets/activity/pages/join-people-33.png"
                alt=""
              />
            </div>

            <div
              v-else
              class="content-wrapper-avatar-item content-wrapper-avatar-three"
            >
              <img src="../../assets/activity/pages/join-people-3.png" alt="" />
            </div>
          </div>
        </div>

        <div class="getBookStatus-footer-success" @click="openSuccessApp">
          {{ successGuideBtnObj.btnName }}
        </div>
      </div>
    </div>
  </div>
  <!-- 组团不成功 -->
  <div class="container-layout" v-show="isFailed">
    <div class="top-wrapper">
      <div v-if="isTeamHimSelfIn" class="icon-wrapper">
        <img src="../../assets/activity/pages/addOne.png" alt="" />
      </div>
      <div class="getBookStatus">
        <div class="getBookStatus-title" v-if="!isTeamHimSelfIn">
          <span>
            <img
              class="right"
              src="../../assets/activity/pages/right.svg"
              alt=""
            />
          </span>
          <span v-if="!flag">
            {{ openGroupTextTitleNewUser }}
          </span>
          <!-- 老用户 -->
          <span v-else>
            {{ openGroupTextTitleOldUser }}
          </span>
        </div>
        <div class="getBookStatus-content" v-if="!isTeamHimSelfIn">
          <div v-if="!flag">
            <div v-for="(item, index) in openGroupTextArrNewUser" :key="index">
              {{ item }}
            </div>
          </div>

          <div v-else>
            <div v-for="(item, index) in openGroupTextArrOldUser" :key="index">
              {{ item }}
            </div>
          </div>
        </div>

        <div
          v-if="beginGuideBtnObj.btnName && !isTeamHimSelfIn"
          class="get-book-status-footer"
          @click="openApp"
        >
          {{ beginGuideBtnObj.btnName }}
          <!-- <img src="../../assets/activity/pages/download.svg" alt="" /> -->
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="content-wrapper-title">
        <p>
          {{ openGroupExplainArr[0] }}
        </p>
        <p>
          {{ openGroupExplainArr[1] }}
        </p>
      </div>
      <div class="content-wrapper-avatar">
        <div class="content-wrapper-avatar-item">
          <img src="../../assets/activity/pages/join-people-1.png" alt="" />
        </div>
        <div>
          <div
            v-if="dataInfo.joinMember !== 0"
            class="content-wrapper-avatar-item content-wrapper-avatar-two"
          >
            <img src="../../assets/activity/pages/join-people-2.png" alt="" />
          </div>
          <div
            v-else
            class="content-wrapper-avatar-item content-wrapper-avatar-two"
          >
            <img src="../../assets/activity/pages/join-null.png" alt="" />
          </div>
        </div>

        <div class="content-wrapper-avatar-item content-wrapper-avatar-three">
          <img src="../../assets/activity/pages/join-null.png" alt="" />
        </div>
      </div>

      <div class="people-number">
        已有
        <span>{{ dataInfo.joinMember + 1 }}</span
        >人，还差
        <span class="gap-number">{{
          dataInfo.totalMember - 1 - dataInfo.joinMember
        }}</span
        >人，加油！
      </div>

      <div>
        <div class="last-time">
          剩余
          <span class="last-time-block">
            {{ d }}
          </span>
          天
          <span class="last-time-block"> {{ h }}</span> :
          <span class="last-time-block"> {{ m }}</span
          >:
          <span class="last-time-block">{{ s }}</span>
        </div>
      </div>
    </div>
    <div class="content-footer">
      <Button class="help-button" @click="shareClickBtn" block>
        {{ dataInfo.activityShareBtn }}
      </Button>
    </div>
    <!-- <share-sheet
      v-model:show="showShareRef"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    /> -->

    <van-popup
      round
      v-model:show="show"
      closeable
      position="bottom"
      overlay
      :style="{ height: '35%' }"
    >
      <div class="popup-title">分享给朋友，完成拼团</div>
      <div style="margin-top: -10px">
        <div class="last-time">
          剩余
          <span class="last-time-block">
            {{ d }}
          </span>
          天
          <span class="last-time-block"> {{ h }}</span> :
          <span class="last-time-block"> {{ m }}</span
          >:
          <span class="last-time-block">{{ s }}</span>
        </div>
      </div>
      <ul class="popup-content">
        <li class="popup-content-item" @click="getPoster">
          <div class="popup-content-item-img">
            <img src="../../assets/activity/pages/poster.png" alt="" />
          </div>
          <span>领取海报</span>
        </li>
        <li
          class="popup-content-item copy-weixin-link"
          :data-clipboard-text="source"
        >
          <div class="popup-content-item-img">
            <img src="../../assets/activity/pages/weixin.png" alt="" />
          </div>
          <span>发给朋友</span>
        </li>
        <li class="popup-content-item copy-link" :data-clipboard-text="source">
          <div class="popup-content-item-img">
            <img src="../../assets/activity/pages/copy.png" alt="" />
          </div>
          <span>复制链接</span>
        </li>
      </ul>
    </van-popup>

    <van-popup
      closeable
      v-model:show="showPoster"
      round
      :close-on-click-overlay="false"
      style="background-color: transparent; min-width: 50%; min-height: 50%"
    >
      <template v-if="shareImage">
        <img :src="shareImage" alt="" class="share-image" />
        <div class="poster-intro">已生成专属海报，长按图片分享海报</div>
      </template>
    </van-popup>
    <div class="poster">
      <div id="imgBox">
        <qrcode-vue
          :value="source"
          :size="54"
          level="H"
          class="qr-activity"
          id="canvasDom"
        />
        <img
          :src="dataInfo.activitySharePosterUrl"
          crossOrigin="anonymous"
          alt=""
        />
      </div>
    </div>
  </div>

  <van-dialog
    v-model:show="showDialog"
    theme="round-button"
    confirmButtonText="先看看，暂不关注"
    id="notify-container"
    :show-confirm-button="false"
  >
    <div style="" class="notify-content">
      <span>您尚未关注公众号，无法接收通知</span>
      <p style="margin-top: 5px">请关注公众号后再回到这里</p>
      <p style="margin-top: 30px">长按扫码关注公众号</p>
      <img src="@/assets/images/QRCode-OA.png" alt="PPtutor公众号二维码" />
      <Button class="oa-button" @click="refresh" round block> 我已关注 </Button>
      <Button class="close-notify" @click="showDialog = false" block round>
        先看看，暂不关注
      </Button>
    </div>
  </van-dialog>
</template>
<style lang="less" scoped>
.isDisplay {
  display: block;
}
.wechat-background {
  img {
    width: 80%;
    position: absolute;
    right: 20px;
    top: 0;
    &.off-icon {
      z-index: 9999;
      width: 28px;
      height: 28px;
      top: 50%;
      left: 50%;
      margin-left: -(28px/2);
    }
  }
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
.poster {
  width: 100vw;
  position: fixed;
  top: 0px;
  left: -1111111110px;
  .qr-activity {
    position: absolute;
    right: 10%;
    bottom: 7.5%;
    width: 20vw !important;
    height: 20vw !important;
  }
  img {
    display: inline-block;
    width: 100%;
    // object-fit: cover;
  }
}
.poster-intro {
  overflow: hidden;
  margin-left: 16px;
  margin-top: 15px;
  font-size: 14px;
  font-family: JiangChengYuanTi;
  line-height: 23px;
  color: #ffffff;
  text-align: center;
}
.share-image {
  width: 70vw;
  border-radius: 20px;
}
.popup-title {
  margin: 30px auto 20px auto;
  width: 100%;
  text-align: center;
  height: 26px;
  font-size: 20px;
  font-family: JiangChengYuanTi;
  font-weight: 500;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.9);
}
.popup-content {
  width: 249px;
  height: 74px;
  margin: 43px auto 0 auto;
  display: flex;
  justify-content: space-between;
  font-family: JiangChengYuanTi;
  .popup-content-item {
    height: 100%;
    width: 54px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.6);
    margin-left: 13px;
    .popup-content-item-img {
      img {
        display: block;
        width: 48px;
        height: 48px;
      }
    }
  }
}
.last-time {
  width: 180px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto 0 auto;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: JiangChengYuanTi;
  .last-time-block {
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    font-weight: 500;
    color: #fe510d;
    margin: 0 3px;
  }
}
.container-layout {
  height: 100vh;
  width: 100%;
  .container-top {
    height: 196px;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
}
.getBookStatusSuccess {
  width: 100%;
  background: #ffffff;
  font-family: JiangChengYuanTi;
  .getBookStatus-title-success {
    color: #fe510d;
    margin-top: 30px;
    display: flex;
    height: 28px;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    .right {
      display: inline-block;
      margin-right: 10px;
    }
  }
  .getBookStatus-content-success {
    padding-top: 10px;
    text-align: center;
    font-size: 16px;
    line-height: 28px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
  }
  .getBookStatus-footer-success {
    margin: 80px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 335px;
    height: 50px;
    background: linear-gradient(90deg, #ff2929 0%, #ff7600 100%);
    border-radius: 27px;
    font-weight: 500;
    font-size: 18px;
    color: #fff;
    border: none;
  }
}
.content-wrapper-avatar-success {
  display: flex;
  width: 124px;
  height: 48px;
  margin: 35px auto;
  .content-wrapper-avatar-item {
    width: 48px;
    height: 48px;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .content-wrapper-avatar-two,
  .content-wrapper-avatar-three {
    z-index: 100;
    position: relative;
    left: -10px;
  }
  .content-wrapper-avatar-three {
    z-index: 100;
    position: relative;
    left: -20px;
  }
}
.download_app {
  margin: 80px auto 0 auto;
  text-align: center;
  width: 335px;
  height: 50px;
  background: linear-gradient(90deg, #ff2929 0%, #ff7600 100%);
  border-radius: 27px;
  font-size: 18px;
  font-family: JiangChengYuanTi;
  font-weight: 500;
  line-height: 50px;
  color: #ffffff;
}

//************组团不成功样式***************8
.top-wrapper {
  height: 310px;
  border: 1px solid transparent;
  background-color: #fe510d;
  width: 100%;
  .icon-wrapper {
    width: 195px;
    height: 180px;
    margin: 40px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .getBookStatus {
    // border: 1px solid black;
    margin: 10px auto 0 auto;
    width: 335px;
    max-height: 210px;
    padding-bottom: 40px;
    background: #fff;
    border-radius: 30px;
    font-family: JiangChengYuanTi;
    .getBookStatus-title {
      padding-top: 20px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 500;
      color: #000000;
      .right {
        display: inline-block;
        margin-right: 10px;
      }
    }
    .getBookStatus-content {
      padding: 10px 0 0 0;
      width: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.8);
    }
    .get-book-status-footer {
      margin: 10px auto 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 180px;
      height: 40px;
      border-radius: 27px;
      font-size: 14px;
      color: #fe510d;
      border: 1px solid #fe510d;
      font-weight: 500;
      img {
        display: inline-block;
      }
    }
  }
}
.content-wrapper {
  padding-bottom: 10px;
  width: 335px;
  max-height: 260px;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
  border-radius: 30px;
  margin-top: -70px;
  margin-left: 20px;
  .content-wrapper-title {
    padding-top: 30px;
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    font-family: JiangChengYuanTi;
    color: #000000;
    line-height: 28px;
  }
  .content-wrapper-avatar {
    display: flex;
    width: 124px;
    height: 48px;
    margin: 23px auto 0 auto;
    .content-wrapper-avatar-item {
      width: 48px;
      height: 48px;
      img {
        width: 48px;
        height: 48px;
      }
    }
    .content-wrapper-avatar-two,
    .content-wrapper-avatar-three {
      z-index: 100;
      position: relative;
      left: -10px;
    }
    .content-wrapper-avatar-three {
      z-index: 100;
      position: relative;
      left: -20px;
    }
  }
  .people-number {
    text-align: center;
    height: 40px;
    margin: 10px auto 0 auto;
    font-size: 14px;
    font-family: JiangChengYuanTi;
    font-weight: normal;
    line-height: 23px;
    color: #000000;
    .gap-number {
      color: #fe510d;
      font-size: 30px;
      margin-right: 1px;
    }
  }
}
.content-footer {
  width: 100%;
  height: 76px;
  position: fixed;
  bottom: 13px;
  .help-button {
    display: block;
    width: 335px;
    height: 50px;
    background: linear-gradient(90deg, #ff2929 0%, #ff7600 100%);
    border-radius: 27px;
    font-size: 18px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    font-weight: 400;
    margin: 13px auto;
    border: none;
  }
}

// notify
#notify-container {
  .close-notify {
    font-family: JiangChengYuanTi;
    font-weight: 400;
    background: #eef4fa;
    color: #818995;
    width: 80%;
  }
  .notify-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 20px;
    font-family: JiangChengYuanTi;
    font-weight: 400;
  }
  .oa-button {
    font-family: JiangChengYuanTi;
    font-weight: 400;
    background: linear-gradient(90deg, #ff2929 0%, #ff7600 100%);
    color: #fff;
    width: 80%;
    margin-bottom: 5px;
  }
}
</style>
